module.exports = __webpack_public_path__ + "__assets__/img/student-login-bg.ea787f05.png";